module.exports = __webpack_public_path__ + "img/制证男.c3ce502c.png";